import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'formattedArea',
    standalone: false,
})
export class FormattedAreaPipe implements PipeTransform {
    transform(areaM2: number): string {
        if (areaM2 == null || isNaN(areaM2) || areaM2 <= 0) {
            return '0 m²';
        }

        const formatter = new Intl.NumberFormat('nl-NL', { maximumFractionDigits: 2 });

        if (areaM2 < 10000) {
            return `${formatter.format(areaM2)} m²`;
        } else if (areaM2 < 1000000) {
            const hectares = areaM2 / 10000;
            return `${formatter.format(hectares)} ha`;
        }
        const km2 = areaM2 / 1000000;
        return `${formatter.format(km2)} km²`;
    }
}
